import React from "react";
import { useTranslation } from "react-i18next";
import { CvCheckCoach } from "../TemplatePreview";
import { CircularImage } from "../../../../../../../../../components/circularImage";
import Button from "../../../../../../../../../components/button";
import {
  ButtonSize,
  ButtonVariant,
} from "../../../../../../../../../components/button/types";

// Helper function (can be shared or duplicated)
const ensureProtocol = (url?: string): string | undefined => {
  if (!url) return undefined;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("//")) return `https:${url}`;
  if (!url.includes(".")) return undefined;
  return undefined;
};

interface CoachSelectionViewProps {
  coaches: CvCheckCoach[] | undefined;
  selectedCoach: CvCheckCoach | null;
  isLoading: boolean;
  error: unknown;
  onSelectCoach: (coach: CvCheckCoach) => void;
  onBack: () => void;
}

export const CoachSelectionView: React.FC<CoachSelectionViewProps> = ({
  coaches,
  selectedCoach,
  isLoading,
  error,
  onSelectCoach,
  onBack,
}) => {
  const { t } = useTranslation("myArea"); // Or appropriate namespace

  return (
    <div className="flex flex-col w-full mt-6">
      {" "}
      {/* Removed padding, parent adds it */}
      {!isLoading && coaches && coaches.length > 0 && (
        <div className="space-y-3 max-h-[50vh] overflow-y-auto pr-2">
          {" "}
          {/* Adjusted max height */}
          {coaches.map((coach) => {
            const profilePicUrl = ensureProtocol(coach.profilePicture);
            const isSelected = selectedCoach?.id === coach.id;
            return (
              <label
                key={coach.id}
                className={`flex items-center cursor-pointer p-3 border rounded-lg transition-colors duration-150 ease-in-out ${
                  isSelected
                    ? "bg-yellow-50 border-yellow-400 shadow-sm ring-1 ring-yellow-300"
                    : "hover:bg-gray-50 border-gray-200"
                }`}
                onClick={() => onSelectCoach(coach)}
              >
                {/* Visual Radio */}
                <div
                  className={`w-5 h-5 border-2 rounded-full flex items-center justify-center border-yellow-500 mr-4 flex-shrink-0`}
                  style={{ aspectRatio: "1" }}
                >
                  <div
                    className={`w-2.5 h-2.5 rounded-full ${
                      isSelected ? "bg-yellow-500" : "bg-transparent"
                    } transition-all`}
                  />
                </div>
                {/* Picture */}
                <div className="w-10 h-10 mr-4 overflow-hidden rounded-full flex-shrink-0 border border-gray-200 bg-gray-100 flex items-center justify-center">
                  {profilePicUrl ? (
                    <CircularImage
                      src={profilePicUrl}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className="text-gray-500 text-lg font-semibold">
                      {coach.name?.charAt(0).toUpperCase()}
                    </span>
                  )}
                </div>

                <span
                  className={`font-medium text-sm ${
                    isSelected ? "text-gray-900" : "text-gray-700"
                  }`}
                >
                  {coach.name}
                </span>
              </label>
            );
          })}
        </div>
      )}
      {!isLoading && !error && (!coaches || coaches.length === 0) && (
        <p className="text-sm text-gray-500 py-4 text-center">
          {t("step4.noCoachesFound")}
        </p>
      )}
      <div
        className="w-full py-3 px-4  lg:py-0 lg:px-0 
  fixed bottom-0 left-0 bg-white 
  lg:relative lg:bottom-auto lg:left-auto lg:bg-transparent"
      >
        <div className="flex justify-end space-x-2 pt-6">
          <Button
            className="w-1/2"
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.SMALL}
            onClick={onBack}
          >
            {t(`assessments.cv-check.back-button`)}
          </Button>
        </div>
      </div>
    </div>
  );
};
